import { exportDocument, type ExportFormat } from "./exportDocument";

/** Format choisi dans le menu d'export : les pages appellent toutes exportCsv, qui suit ce choix. */
let requestedFormat: ExportFormat = "excel";

/** Lance l'export d'une page dans le format demandé. */
export function runExport(format: ExportFormat, onExport: () => void) {
  requestedFormat = format;
  try {
    onExport();
  } finally {
    requestedFormat = "excel";
  }
}

/** Exporte un tableau en PDF ou en Excel (Excel hors du menu d'export, pour une ligne seule). */
export function exportCsv(filename: string, headers: string[], rows: Array<Array<string | number>>) {
  void exportDocument(requestedFormat, filename, headers, rows);
}
